import AvatarCore from "@/features/avatar/core/AvatarCore";

interface AvatarCardProps {
  modelUrl?: string;
  fbxUrl?: string;
  height?: string;
  isAvaturnModel?: boolean;
  scaleOverride?: number;
  cameraDistanceOverride?: number;
  lookAtYOverride?: number;
}

export default function AvatarCard({
  modelUrl = "/avatar/model_small.glb",
  fbxUrl,
  height = "260px",
  isAvaturnModel = false,
  scaleOverride,
  cameraDistanceOverride,
  lookAtYOverride,
}: AvatarCardProps) {
  return (
    <AvatarCore
      modelUrl={modelUrl}
      height={height}
      isAvaturnModel={isAvaturnModel}
      scaleOverride={scaleOverride}
      cameraDistanceOverride={cameraDistanceOverride}
      lookAtYOverride={lookAtYOverride}
      animationUrl={fbxUrl}
    />
  );
}
